import { useEffect, useState, useRef } from "react";
import { Container } from "react-bootstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import styles from "./home.module.css";
import Companies from "../COMPONENTS/COMPANIES";
import kurIntText from "../ASSETS/LOGO/kurLogoText.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDownLong } from "@fortawesome/free-solid-svg-icons";
import atlasIndia from "./../ASSETS/IMAGES/AtlasEssenIndia.webp";
import atlasUSA from "./../ASSETS/IMAGES/AtlasEssentials.jpg";
import Vexillum from "./../ASSETS/IMAGES/Vexillum.jpg";
import kurdiagnostics from "./../ASSETS/IMAGES/KurDiagnostics.jpg";
import ucct from "./../ASSETS/IMAGES/KurAllergy.jpg";
import KurResearch from "./../ASSETS/IMAGES/KurResearch.jpg";
import atlasIndiaLogo from "./../ASSETS/LOGO/Atlas.png";
import atlasUSALogo from "./../ASSETS/LOGO/Atlas.png";
import VexillumLogo from "./../ASSETS/LOGO/VEXILLUM.png";
import kurdiagnosticsLogo from "./../ASSETS/LOGO/KUR_DIAGNOSTICS.png";
import ucctLogo from "./../ASSETS/LOGO/UCCT.png";
import KurResearchLogo from "./../ASSETS/LOGO/KUR_RESEARCH.png";
import kerevanalogo from "./../ASSETS/LOGO/kerevanalogo.png";
import Kerevna from "./../ASSETS/IMAGES/Kerevna.webp";

function HomePage() {
  const currentYear = new Date().getFullYear();
  const companyData = [
    {
      title: "Kerevna",
      imageUrl: Kerevna,
      description: `Kerevna is a globally recognized Contract Research Organization (CRO) offering a full 
      spectrum of clinical development services. From startup biotechs to top pharmaceutical companies, 
      we help you accelerate outcomes through scientific rigor and regulatory strategy.`,
      siteUrl: "https://www.kerevna.com/",
      logo: kerevanalogo,
    },
    {
      title: "ATLAS ESSENTIALS USA",
      imageUrl: atlasUSA,
      description: `Atlas Essentials is the management organization for all KUR International Companies.
      Atlas provides full administrative support and integrated infrastructure in support of all KUR’s global teams.`,
      siteUrl: "https://atlasessentials.com/",
      logo: atlasUSALogo,
    },
    {
      title: "ATLAS ESSENTIALS INDIA",
      imageUrl: atlasIndia,
      description: `Atlas Essentials India is the subsidiary of Atlas Essential LLC USA.
      Atlas India provides full administrative support and integrated infrastructure in support of all KUR’s global teams.`,
      siteUrl: "https://in.atlasessentials.com/",
      logo: atlasIndiaLogo,
    },
    {
      title: "KUR DIAGNOSTICS",
      imageUrl: kurdiagnostics,
      description: `KUR Diagnostics provides various preventative care and screening programs. providing results which show patient’s present health risks and helps physicians in developing an individualized care plan to reduce future risk of experiencing life-threatening issues.`,
      siteUrl: "https://www.kurdiagnostics.com",
      logo: kurdiagnosticsLogo,
    },
    {
      title: "VEXILLUM",
      imageUrl: Vexillum,
      description: `Vexillum offers prospective and retrospective bio samples collections for clients through its own IRB approved protocol.`,
      siteUrl: "https://vexillumllc.com/",
      logo: VexillumLogo,
    },
    {
      title: "UCC TRIALS",
      imageUrl: ucct,
      description: `Urgent Care Clinical Trials (UCCT) is the first Fully Integrated Clinical Research Site Management Organization dedicated specifically to the urgent care industry. Specializing in acute infectious disease, UCCT has performed hundreds of clinical research projects enrolling thousands of subjects.`,
      siteUrl: "https://urgentcareclinicaltrials.com/",
      logo: ucctLogo,
    },
    {
      title: "KUR RESEARCH",
      imageUrl: KurResearch,
      description: `KUR Research is a Fully Integrated Clinical Research Site Management Organization with a proven track record of success performing hundreds of clinical trials.`,
      siteUrl: "https://kurr.com/",
      logo: KurResearchLogo,
    },
  ];
  const [zoomedOut, setZoomedOut] = useState(false);
  const [imageSettled, setImageSettled] = useState(false);
  const [animationStarted, setAnimationStarted] = useState(false);
  const [textPosition, setTextPosition] = useState(0);
  const [isTextGone, setIsTextGone] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 1024); // Changed to 1024px
  const textContainerRef = useRef(null);
  const logoRef = useRef(null);
  const companyRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 1024); // Changed to 1024px
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!isSmallScreen) {
      AOS.init({
        duration: 1000,
        once: true,
        offset: 100,
      });

      const handleWheel = (e) => {
        e.preventDefault();
        if (!zoomedOut) {
          setZoomedOut(true);
          setTimeout(() => {
            setImageSettled(true);
          }, 1000);
        }

        const windowHeight = window.innerHeight;
        const scrollFactor = 0.5;

        if (e.deltaY > 0 && !animationStarted) {
          setAnimationStarted(true);
          setTextPosition((prev) =>
            Math.min(prev + windowHeight * scrollFactor, windowHeight * 5)
          );
          setIsTextGone(true);
        }
      };

      window.addEventListener("wheel", handleWheel, { passive: false });
      return () => window.removeEventListener("wheel", handleWheel);
    } else {
      setImageSettled(true);
      setAnimationStarted(true);
    }
  }, [zoomedOut, animationStarted, isSmallScreen]);

  const handlePartnershipClick = () => {
    if (!isSmallScreen && !animationStarted) {
      setAnimationStarted(true);
      setZoomedOut(true);
      setTimeout(() => setImageSettled(true), 1000);
      setTextPosition(500);
      setIsTextGone(true);
    } else {
      companyRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <Container fluid className={styles.homepagecontainer}>
        <div>
          <div className={styles.logoSection}>
            <div className={styles.imageContainer}>
              <div
                className={`${styles.ring} ${styles.ring1} ${
                  imageSettled && !isSmallScreen ? styles.ringSettled : ""
                } ${imageSettled && !isSmallScreen ? styles.ringActive : ""}`}
              ></div>
              <div
                className={`${styles.ring} ${styles.ring2} ${
                  imageSettled && !isSmallScreen ? styles.ringSettled : ""
                } ${imageSettled && !isSmallScreen ? styles.ringActive : ""}`}
              ></div>
              <img
                src={KurResearchLogo}
                alt="Kur International Logo"
                className={`${styles.zoomImage} ${
                  zoomedOut && !isSmallScreen ? styles.zoomImageSettled : ""
                }`}
                ref={logoRef}
              />
              <img
                src={kurIntText}
                alt="Kur International"
                className={`${styles.kurIntText} ${
                  zoomedOut && !isSmallScreen ? styles.kurIntTextSettled : ""
                }`}
              />
            </div>

            <div
              className={styles.heroContainer}
              style={{
                transform: !isSmallScreen
                  ? `translateY(${textPosition}px)`
                  : "none",
                transition: "transform 1s ease-out",
              }}
            >
              <div
                ref={textContainerRef}
                className={`${styles.textContainer} ${
                  isTextGone && !isSmallScreen ? styles.textContainerHidden : ""
                }`}
              >
                <h3>
                  KUR International is a global healthcare conglomerate
                  dedicated to furthering science, research, and patient
                  well-being. We{" "}
                  <span className={styles.highlightText}>
                    make progress possible
                  </span>{" "}
                  by delivering an advanced and seamless clinical experience for
                  patients resulting in a superior healthcare outcome.
                </h3>

                <div
                  className={styles.partnershipContainer}
                  onClick={handlePartnershipClick}
                >
                  <p className={styles.partnershipText}>View Partnerships</p>
                  <FontAwesomeIcon
                    icon={faArrowDownLong}
                    className={styles.arrow}
                  />
                </div>
              </div>
            </div>
          </div>

          {(imageSettled || isSmallScreen) && (
            <div
              ref={companyRef}
              className={`${styles.companyContainer} ${
                (imageSettled && !isSmallScreen) || isSmallScreen
                  ? styles.companyContainerActive
                  : ""
              }`}
            >
              {(isSmallScreen ? companyData.reverse() : companyData).map(
                (company, index) => (
                  <Companies
                    key={index}
                    size={isSmallScreen ? "11em" : "7rem"}
                    index={index}
                    totalCompanies={companyData.length}
                    title={company.title}
                    description={company.description}
                    siteUrl={company.siteUrl}
                    imageUrl={company.imageUrl}
                    logo={company.logo}
                    logoRef={logoRef}
                  />
                )
              )}
            </div>
          )}
        </div>
        <div className={styles.copywright}>
          Copyright © {currentYear} KUR International
        </div>
      </Container>
    </>
  );
}

export default HomePage;
